class AnnouncementBarSection extends BTSection {
	onInit() {
		if(this.timeout) {
			clearTimeout(this.timeout);
		}
		this.timeout = setTimeout(() => {
			BT.initSlider(this.container, true);
		}, (!Shopify.designMode ? 500 : 0));
	}

	onLoad(evt) {
		BT.convertCurrencySilence(this.container.find('.money'));
	}

	onBlockSelect(evt) {
    const ele = $(evt.target);
    if(ele.attr('data-slick-index') != undefined) {
      ele.parents('.use-slider').first().slick('slickGoTo', ele.attr('data-slick-index'), true).slick('slickPause');
    }
  }

  onBlockDeselect(evt) {
    // Resume auto-rotate
    const ele = $(evt.target);
    const slider = ele.parents('.use-slider').first();
    if(slider.hasClass('slick-initialized')) {
      slider.slick('slickPlay');
    }
  }
}
theme.sections.constructors['announcement-bar'] = AnnouncementBarSection;